import React from "react";
import PollingResultProgressBar from "../PollingResultProgressBar.component";

const PollingResult = ({ data }) => {
  return (
    <div className="p-1 w-full h-fit flex-col align-start justify-start g-2 radius-6 back-white">
      <span className="w-full text-align-center poppins color-grayColor">
        Poll result released
      </span>

      <div className="flex-col align-start justify-start g-05">
        <div
          className="flex-row align-center justify-start g-05 pt-1 pb-1"
          style={{ borderBottom: "1.5px solid var(--grayBorder)" }}
        >
          <span className="poppins t-14 color-black">Time:</span>
          <span className="poppins t-14 color-grayColor">
            {data?.timestamp}
          </span>
        </div>
        <div
          className="flex-row align-center justify-start g-05 pt-1 pb-1"
          style={{ borderBottom: "1.5px solid var(--grayBorder)" }}
        >
          <span className="poppins t-14 color-black">Purpose:</span>
          <span className="poppins t-14 color-grayColor">
            {" "}
            {data?.purpose}{" "}
          </span>
        </div>
        <div
          className="flex-row align-center justify-start g-05 pt-1 pb-1"
          style={{ borderBottom: "1.5px solid var(--grayBorder)" }}
        >
          <span className="poppins t-14 color-black">End time:</span>
          <span className="poppins t-14 color-grayColor">{data?.endTime}</span>
        </div>
      </div>

      <div className="flex-col align-start justify-start g-1">
        {data?.results.map((result) => (
          <PollingResultProgressBar
            key={"fg"}
            name={result?.name}
            designation={result?.designation}
            color={result?.color}
            background={result?.backgroundColor}
            percentage={result?.percentage}
          />
        ))}
      </div>
    </div>
  );
};

export default PollingResult;
